import { Reveal } from "./Reveal";
import { FAQS } from "@/data/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const Faq = () => {
  return (
    <section id="faq" data-testid="faq" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-3xl px-5 lg:px-8">
        <div className="text-center">
          <Reveal>
            <span className="font-heading text-xs font-semibold uppercase tracking-[0.24em] text-brand-blue">
              Häufige Fragen
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl">
              Alles, was du wissen <span className="text-gradient-brand">musst.</span>
            </h2>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="overflow-hidden rounded-2xl border border-white/10 bg-brand-surface px-5 !border-b sm:px-6"
              >
                <AccordionTrigger className="py-5 font-heading text-base font-semibold text-white hover:no-underline [&>svg]:text-brand-green sm:text-lg">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 font-body text-sm leading-relaxed text-white/65 sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
